import React from 'react';
import { Monitor, Smartphone, CheckCircle } from 'lucide-react';
import type { AcceptanceRecord } from '../data';

interface TableProps {
    records: AcceptanceRecord[];
}

export const AceptacionesTable: React.FC<TableProps> = ({ records }) => {
    return (
        <div className="flex flex-col flex-1 w-full min-h-[400px] bg-white">
            <div className="w-full h-full overflow-auto hide-scrollbar">
                <table className="w-full min-w-[900px] border-collapse">
                    <thead className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200 shadow-sm">
                        <tr>
                            <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">ID Registro</th>
                            <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">Usuario</th>
                            <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">Fecha Aceptación</th>
                            {/* <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">Versión Aceptada</th> */}
                            <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">IP / Origen</th>
                            <th className="px-4 sm:px-7 py-3 text-left text-[10px] font-bold tracking-[0.8px] text-gray-500 uppercase whitespace-nowrap">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.length === 0 ? (
                            <tr>
                                <td colSpan={6} className="px-4 py-10 text-center text-sm text-gray-500">
                                    No se encontraron registros de aceptación.
                                </td>
                            </tr>
                        ) : (
                            records.map((record) => (
                                <tr key={record.id} className="transition-colors hover:bg-gray-50 border-b border-gray-100">
                                    <td className="px-4 sm:px-7 py-3.5 text-[13px] align-middle">
                                        <span className="text-[11px] font-mono font-medium text-gray-500">{record.id}</span>
                                    </td>
                                    
                                    <td className="px-4 sm:px-7 py-3.5 align-middle">
                                        <div className="flex items-center gap-2.5">
                                            <div className={`flex items-center justify-center shrink-0 w-7 h-7 text-[10px] font-bold text-white rounded-full ${record.avatarColor}`}>
                                                {record.userInitials}
                                            </div>
                                            <div className="text-[13px] font-medium text-gray-900 whitespace-nowrap">{record.userName}</div>
                                        </div>
                                    </td>

                                    <td className="px-4 sm:px-7 py-3.5 text-[12px] text-gray-700 align-middle">
                                        {record.acceptedAt} <span className="text-[10px] text-gray-400 ml-1">{record.time}</span>
                                    </td>

                                    {/* <td className="px-4 sm:px-7 py-3.5 align-middle">
                                        <span className="px-2 py-1 text-[11px] font-medium bg-gray-100 text-gray-700 rounded-md border border-gray-200 whitespace-nowrap">
                                            {record.documentVersion}
                                        </span>
                                    </td> */}

                                    <td className="px-4 sm:px-7 py-3.5 align-middle">
                                        <div className="flex flex-col">
                                            <span className="font-mono text-[11px] text-gray-900">{record.ipAddress}</span>
                                            <div className="flex items-center gap-1 mt-0.5 text-gray-500">
                                                {record.device.includes('iOS') || record.device.includes('Android') ? (
                                                    <Smartphone size={10} />
                                                ) : (
                                                    <Monitor size={10} />
                                                )}
                                                <span className="text-[10px]">{record.device}</span>
                                            </div>
                                        </div>
                                    </td>

                                    <td className="px-4 sm:px-7 py-3.5 align-middle">
                                        {record.status === 'vigente' ? (
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase rounded-full whitespace-nowrap bg-emerald-50 text-emerald-700 border border-emerald-100">
                                                <CheckCircle size={10} /> Vigente
                                            </span>
                                        ) : (
                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase rounded-full whitespace-nowrap bg-amber-50 text-amber-700 border border-amber-100">
                                                Histórico
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
